import React, {useContext, useState, useEffect} from 'react';
import './Tags.css';
import axios from 'axios';
import config from '../../../config';
import { AuthContext } from '../../../contexts/authContext';
import { EditIcon, TrashIcon, AddIcon, CachedIcon } from '../../../assets/icons/icons';
import { IconButton } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { itIT } from '@mui/x-data-grid/locales';
import { AppAuthGlobalVariables } from '../../../contexts/AppAuthContext';
import {
    DataGridPremium
} from '@mui/x-data-grid-premium';
import ManageTagsDialog from './ManageTagsDialog';
import DeleteTagsDialog from './DeleteTagsDialog';
import { LicenseInfo } from '@mui/x-license';
import useNotification from '../../../hooks/useNotification';

LicenseInfo.setLicenseKey(config.MUI_DATA_GRID_PREMIUM_LICENSE);

const theme = createTheme(
    {
      palette: {
        primary: { main: '#1976d2' },
      },
    },
    itIT,
);

const ActionCell = (params, openDialog, openDeleteDialog) => {
    return(
        <div>
            <IconButton onClick={() => openDialog('mod')} size='small' >
                <EditIcon addClass='pointer'></EditIcon>
            </IconButton>
            <IconButton onClick={openDeleteDialog} size='small'>
                <TrashIcon addClass="pointer" ></TrashIcon>
            </IconButton>
        </div>
    )
}

const ActionHeaderCell = (params, openDialog, getTags, getGroups, getTickersEmergenza) => {
    return(
        <div className="centered-cell" >
            <IconButton title='Ricarica dati' onClick={() => {getTags(); getGroups(); getTickersEmergenza()}} size='small' >
                <CachedIcon addClass='pointer'/>
            </IconButton>
            <IconButton onClick={() => openDialog('ins')} size='small' title='Inserisci Fermata' >
                <AddIcon addClass='pointer'/>
            </IconButton>
        </div>
    )
}

function Tags(props) {
    const auth = useContext(AuthContext);
    const { tags, setTags, tickers, setTickers, tickersEmergenza, setTickersEmergenza } = useContext(AppAuthGlobalVariables);
    const { notificationError } = useNotification();

    const [loading, setLoading] = useState(true);
    const [tagsLoading, setTagsLoading] = useState(true);

    const [tickersAutocomplete, setTickersAutocomplete] = useState([]);
    const [tickersEmergenzaAutocomplete, setTickersEmergenzaAutocomplete] = useState([]);

    const [openManageTagsDialog, setOpenManageTagsDialog] = useState(false);
    const [openDeleteTagsDialog, setOpenDeleteTagsDialog] = useState(false);
    const [lastCellData, setLastCellData] = useState(null);

    const columns = [
        {field: 'ACTION', headerClassName: 'header-cell action-cell', headerName: '', type: 'string', width: 100, align: 'center', headerAlign: 'center', disableColumnMenu: true, sortable: false, disableExport: true, renderHeader: (params) => ActionHeaderCell(params, handleOpenManageTagsDialog, getTickers, getTags, getTickersEmergenza), renderCell: (params) => ActionCell(params, handleOpenManageTagsDialog, handleOpenDeleteTagsDialog)},
        /* {field: 'idEntita', headerClassName: 'header-cell id', headerName: 'Numero Fermata', type: 'string', width: 150, align: 'right', headerAlign: 'right', valueGetter: (params) => params?.S}, */
        {field: 'descrizione', headerClassName: 'header-cell descrizione', headerName: 'Descrizione', type: 'string', flex: 1, align: 'left', headerAlign: 'left', valueGetter: (params) => params?.S},
        //{field: 'tickerList', headerClassName: 'header-cell tickerList', headerName: 'Ticker associati', type: 'string', flex: 1, align: 'left', headerAlign: 'left', valueGetter: (params) => params?.SS?.join(', ') || ''},
        //{field: 'tickerEmergenzaList', headerClassName: 'header-cell tickerEmergenzaList', headerName: 'Ticker emergenza associati', type: 'string', flex: 1, align: 'left', headerAlign: 'left', valueGetter: (params) => params?.SS?.join(', ') || ''},
    ]

    useEffect(() => {
        if(!tags.length || !tickers.length || !tickersEmergenza.length){
            getTags();
            getTickers();
            getTickersEmergenza();
        }else{
            convertTickersForAutocomplete(tickers);
            convertTickersEmergenzaForAutocomplete(tickersEmergenza);
            setTagsLoading(false);
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if(!loading){
            getTags();
            getTickers();
            getTickersEmergenza();
        }
    }, [props.city])

    const getTags = async() => {
        try {
            setLoading(true);
            setTagsLoading(true);

            const params = {
                city: props.city
            };

            const axiosParams = {
                url: '/get-tags',
                method: 'get',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
                params
            };

            const response = await axios(axiosParams);
            setTags(response.data.dataToReturn);
            //setRows(response.data.dataToReturn);
            setTagsLoading(false);
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error?.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setTagsLoading(false);
            setLoading(false);
        }
    }

    const getTickers = async() => {
        try {
            const params = {
                city: props.city
            };

            const axiosParams = {
                url: '/get-tickers',
                method: 'get',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
                params
            };

            const response = await axios(axiosParams);
            const allTickers = response.data.dataToReturn;
            
            setTickers(allTickers);
            convertTickersForAutocomplete(allTickers);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error?.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
        }
    }

    const getTickersEmergenza = async() => {
        try {

            const params = {
                city: props.city
            };

            const axiosParams = {
                url: '/get-tickers-emergenza',
                method: 'get',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
                params
            };

            const response = await axios(axiosParams);
            const allTickers = response.data.dataToReturn;

            setTickersEmergenza(allTickers);
            convertTickersEmergenzaForAutocomplete(allTickers);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error?.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
        }
    }

    const convertTickersForAutocomplete = (list) => {
        let copyList = [...list] || [];
        for (let index = 0; index < copyList.length; index++) {
            let element = copyList[index];
            
            let newElement = {
                id: element?.idEntita?.S,
                label: element?.titolo?.S || ''
            };
            copyList[index] = newElement;
        }

        setTickersAutocomplete(copyList);
    }

    const convertTickersEmergenzaForAutocomplete = (list) => {
        let copyList = [...list] || [];
        for (let index = 0; index < copyList.length; index++) {
            let element = copyList[index];
            
            let newElement = {
                id: element?.idEntita?.S,
                label: element?.titolo?.S || ''
            };
            copyList[index] = newElement;
        }

        setTickersEmergenzaAutocomplete(copyList);
    }

    const handleOpenManageTagsDialog = (action) => {
        setOpenManageTagsDialog(action)
    }
    const handleCloseManageTagsDialog = () => {
        setOpenManageTagsDialog(false);
    }

    const handleOpenDeleteTagsDialog = () => {
        setOpenDeleteTagsDialog(true);
    }   
    const handleCloseDeleteTagsDialog = () => {
        setOpenDeleteTagsDialog(false);
    }

    return (
        <div className='component-container tags'>
            <div className='component-card'>
                <ThemeProvider theme={theme}>
                    <DataGridPremium
                        rows={tags}
                        columns={columns}
                        className="tags-table"
                        loading={tagsLoading}
                        rowHeight={30}
                        onCellClick={(params) => setLastCellData(params.row)}
                        getRowId={(row) => row.idEntita.S}
                        disableAggregation
                        disableRowGrouping
                        disableDensitySelector
                        //slots={{
                        //    toolbar: ()=>CustomToolbar(),
                        //}}
                    />
                </ThemeProvider>
            </div>
            <ManageTagsDialog {...{
                openManageTagsDialog,
                handleCloseManageTagsDialog,
                lastCellData,
                getTags,
                tickers: tickersAutocomplete,
                tickersEmergenza: tickersEmergenzaAutocomplete,
                city: props.city
            }}/>
            <DeleteTagsDialog {...{
                openDeleteTagsDialog,
                handleCloseDeleteTagsDialog,
                lastCellData,
                getTags
            }}/>
        </div>
    )
}

export default Tags